import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const PartnerSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const partners = [
    { id: 1, img: "assets/img/service/service_card_1_1.png" },
    { id: 2, img: "assets/img/service/service_card_1_1.png" },
    { id: 3, img: "assets/img/service/service_card_1_1.png" },
    { id: 4, img: "assets/img/service/service_card_1_1.png" },
    { id: 5, img: "assets/img/service/service_card_1_1.png" },
    { id: 6, img: "assets/img/service/service_card_1_1.png" },
  ];

  return (
    <>
    <div className="partner-slider-container">
      <h2 className="slider-title">Our Partners</h2>
      <Slider {...settings}>
        {partners.map((partner) => (
          <div key={partner.id} className="partner-slide">
            <img src={partner.img} alt={`Partner ${partner.id}`} />
            
          </div>







        ))}
      </Slider>
    </div>
    </>
  );
};

export default PartnerSlider;
